export default class TableAbstractFeature {
  constructor(table) {
    this.component = table;
    this.dom = this.component.dom;

    this.callbacks = {
      beforeCreatedHead: this.beforeCreatedHead.bind(this),
      onCreatedHead: this.onCreatedHead.bind(this),
      beforeCreatedBody: this.beforeCreatedBody.bind(this),
      onCreatedBody: this.onCreatedBody.bind(this),
      onCreatedRow: this.onCreatedRow.bind(this),
      onCreatedDetailsRow: this.onCreatedDetailsRow.bind(this),
      onToggleSelectRow: this.onToggleSelectRow.bind(this),
      onChangedSettings: this.onChangedSettings.bind(this)
    };
  }

  init() {}

  destroy() {}

  update(eventName, ...args) {
    if (this.callbacks[eventName]) {
      this.callbacks[eventName](...args);
    }
  }

  beforeCreatedHead() {}

  onCreatedHead() {}

  beforeCreatedBody() {}

  onCreatedBody() {}

  onCreatedRow() {}

  onCreatedDetailsRow() {}

  onToggleSelectRow() {}

  onChangedSettings() {}
}
